export const CHARACTER_CARD_DIMENSION_WIDTH = "304px"
export const CHARACTER_CARD_DIMENSION_HEIGHT = "432px"
